import { Header } from "@src/components";
import { Icon, useTheme } from "@merit/frontend-components";
// eslint-disable-next-line no-restricted-imports
import { ScrollView, StyleSheet, Text, View } from "react-native";
import { useConfig, useNavigation } from "@src/hooks";
import type { TextStyle, ViewStyle } from "react-native";

export const ConfigInfo = () => {
  const { theme } = useTheme();
  const styles = StyleSheet.create<{
    readonly container: ViewStyle;
    readonly content: ViewStyle;
    readonly monospace: TextStyle;
  }>({
    container: {
      backgroundColor: theme.colors.background.white,
      flex: 1,
    },
    content: {
      padding: theme.spacing.l,
      rowGap: theme.spacing.xxl,
    },
    monospace: {
      fontFamily: "monospace",
    },
  });

  const config = useConfig();
  const nav = useNavigation();

  return (
    <View style={styles.container}>
      <Header
        leftElement={<Icon name="chevronLeftMediumAction" />}
        leftOnPress={() => {
          nav.goBack();
        }}
        title="Config Info"
        titleBold
        titleLevel="3"
      />
      <ScrollView contentContainerStyle={styles.content}>
        <Text style={styles.monospace}>{JSON.stringify(config, null, 2)}</Text>
      </ScrollView>
    </View>
  );
};
